var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.step === 0)?_c('ScanReturnTicketList',{attrs:{"routeFlag":_vm.routeFlag},on:{"nexStep":_vm.nexStep,"scan":_vm.scan}}):_vm._e(),(_vm.step === 1)?_c('ScanReturnTicket',{attrs:{"productOrder":_vm.productOrder},on:{"prevStep":_vm.prevStep,"nexStep":_vm.nexStep}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }